<template>
    <div>
        <el-input type="textarea" v-model="textValue" @keyup.enter.native='keydown' rows='6' ></el-input>
        <el-button @click="submit" >提交</el-button>
    </div>
</template>

<script>
export default {
    props:['value'],
    data(){
        return {
            textValue:'ab\nab'
        }
    },
    methods:{
        submit(){
            let arr = this.textValue.split('\n')
            console.log(arr)
        },
        keydown(){
            // this.textValue+=":"  
        }
    }
}
</script>

<style>

</style>
